import React from 'react';
const chips = ['No forms to fill', 'Refunded to your original payment method', 'Keep the bonuses'];
export function Guarantee() {
  return <section aria-labelledby="guarantee-heading" className="w-full bg-sage-soft" data-id="element-104" data-mp="1o3dmwcdeadr5">
      <div className="mx-auto max-w-3xl px-5 py-16 text-center sm:py-20" data-id="element-105" data-mp="2223ljwfv4lhm">
        <div className="mx-auto flex h-24 w-24 flex-col items-center justify-center rounded-full bg-white text-sage-deep shadow-card ring-4 ring-sage/40" data-id="element-106" data-mp="1x42054uysa2z">
          <span className="font-display text-4xl leading-none" data-id="element-107" data-mp="19co4oq1inyds">7</span>
          <span className="text-xs font-bold" data-id="element-108" data-mp="14h8x2fu3qypt">days</span>
        </div>
        <p className="mt-6 text-sm font-semibold text-sage-deep" data-id="element-109" data-mp="1j4txu33i8luk">Zero risk</p>
        <h2 id="guarantee-heading" className="mt-3 font-display text-3xl text-navy sm:text-5xl" data-id="element-110" data-mp="1ee3tmt6tep1g">
          Open everything. <span className="wash-text" data-id="element-111" data-mp="qnpwio9di000">Teach a class from it.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-navy-soft" data-id="element-112" data-mp="lp6bcq2lss8p">
          Read the volumes, print a Class Plan, teach it straight from the
          page. If Bollywood Class Ready doesn&apos;t change how you plan your
          classes, email us within 7 days and you get every cent back.
        </p>
        <ul className="mt-7 flex flex-wrap justify-center gap-2.5" data-id="element-113" data-mp="ypl2pknk798a">
          {chips.map(chip => <li key={chip} className="rounded-full bg-white px-4 py-2 text-[13px] text-navy-soft" data-id="element-114" data-mp="12rg1ahe3v8id">{chip}</li>)}
        </ul>
      </div>
    </section>;
}